<template>
    <div class="home">
        <header-nav />
        <div class="content">
            <div
                v-for="(i, index) in agreementTxt"
                :key="index"
                class="content__item"
            >
                <div v-if="i === ' '">111</div>
                <div v-else-if="i" >{{ formatTxt(i) }}</div>
                <div v-else > <br/> </div>
            </div>
        </div>
        <app-footer />
    </div>
</template>

<script>
import HeaderNav from '@/components/app/Header';
import AppFooter from '@/components/app/Footer';
import {request} from '@/utils/request';

export default {
    name: 'agreement',
    components: {
        HeaderNav,
        AppFooter
    },
    data() {
        return {
            agreementTxt: []
        };
    },
    mounted() { },
    created() {
        request({
            url: 'https://expert.baidu.com/zhuanjia/med/page/agreement',
            data: {
                pd: 'med',
                openapi: 1,
                from_sf: 1,
                resource_id: 5216,
                vn: 'med',
                type: 'all',
                atn: 'agreement',
                sf_ref: 'pc-sigma'
            }
        }).then(res => {
            this.agreementTxt = res.data.usrAgreement.body.content[0].txt;
        });
        window.scrollTo(0, 0);
    },
    methods: {
        // 替换相关字符
        formatTxt(str) {
            return str.replace(/<\/*b>|\s/g, '');
        }
    }
};
</script>

<style lang="less" scoped>
.content {
    width: 60%;
    margin: 0 auto 20px auto;
    font-family: FZLTXHK--GBK1-0;
    line-height: 25px;
    font-size: 18px;
    &__item {
        &:first-child {
            font-size: 32px;
            text-align: center;
            margin: 20px 0px 40px 0;
            font-weight: 600;
        }
        text-align: justify;
        text-justify: distribute-all-lines;
    }
}
.logo {
    height: 200px;
    width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/pages/app/agreement.vue